import { ReplyApi } from 'api/ApiHelper';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useUnLikeReplyMutation = (id: number, options: UseMutationOptions) =>
  useMutation({ mutationFn: () => ReplyApi.unlikeReply(id), ...options });
